/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import PrimaryButton from '../../buttons/primary-button';
import { ReactComponent as ModalCloseSvg } from '../../../../assets/svgs/modal-close.svg';
import './modal.scss';

const Modal = ({
  title,
  children,
  onSubmit,
  onCancel,
  submitText,
  cancelText,
  maxWidth,
  submitting,
}) => (
  <div className="ca-modal">
    <div className="ca-modal__overlay" onClick={onCancel} />
    <div className="ca-modal__wrapper">
      <div
        className="ca-modal__content"
        style={{ maxWidth: maxWidth ?? '440px' }}
      >
        <button
          className="ca-modal__close"
          type="button"
          onClick={onCancel}
          aria-label="Close Modal Button"
        >
          <ModalCloseSvg />
        </button>
        <div className="ca-modal__header">{title}</div>
        <div className="ca-modal__body">{children}</div>
        <div className="ca-modal__actions">
          <button
            type="button"
            className="button button--default"
            onClick={onCancel}
          >
            {cancelText}
          </button>

          <PrimaryButton
            isLoading={submitting}
            onClick={onSubmit}
            title={submitText}
          />
        </div>
      </div>
    </div>
  </div>
);

export default Modal;
